import { FormControlLabel } from '@mui/material';
import * as S from './custom-checkbox.styles';
import React, { forwardRef } from 'react';

const CustomCheckbox = forwardRef(
  ({ label, errors, dataTestId, sx, ...rest }, ref) => {
    return (
      <FormControlLabel
        sx={{
          alignItems: 'center',
          '.MuiFormControlLabel-label': { fontSize: '0.875rem' },
          ...sx,
        }}
        data-testid={dataTestId}
        control={
          <S.StyledCustomCheckbox error={errors} inputRef={ref} {...rest} />
        }
        label={label}
      />
    );
  },
);

export default CustomCheckbox;
